const CloseIcon = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M2.46967 3.59173C2.17678 3.29884 2.17678 2.82397 2.46967 2.53107C2.76256 2.23818 3.23744 2.23818 3.53033 2.53107L8.09619 7.09694L12.7227 2.47042C13.0156 2.17752 13.4905 2.17752 13.7834 2.47042C14.0763 2.76331 14.0763 3.23818 13.7834 3.53107L9.15685 8.1576L13.7834 12.7841C14.0763 13.077 14.0763 13.5519 13.7834 13.8448C13.4905 14.1377 13.0156 14.1377 12.7227 13.8448L8.09619 9.21826L3.53033 13.7841C3.23744 14.077 2.76256 14.077 2.46967 13.7841C2.17678 13.4912 2.17678 13.0164 2.46967 12.7235L7.03553 8.1576L2.46967 3.59173Z"
  />
);

export default CloseIcon;
